/* eslint-disable */
import React, { useEffect, useState, useRef } from "react"
import { Controller, type Control } from "react-hook-form"
import { graphql } from "gatsby"

export const query = graphql`
  fragment FormInputCheckbox on DatoCmsFormInputCheckbox {
    id
    options
    name
    label
    required
    model {
      apiKey
    }
  }
`

interface FormInputCheckbox extends Queries.FormInputCheckboxFragment {
  control: Control
  getValues: any
  setValue?: any
  columns?: number
}

type FormInputCheckboxProps = Omit<FormInputCheckbox, "id">

const FormInputMultiCheckbox = ({
  columns = 1,
  control,
  label,
  name,
  required,
  options,
  setValue,
  getValues,
}: FormInputCheckboxProps) => {
  const [selectedItems, setSelectedItems] = useState<any>([])
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSelect = (value: any) => {
    if (inputRef?.current) {
      // On change we reset the validity
      inputRef.current.setCustomValidity("")
      inputRef.current.reportValidity()
    }

    const isPresent = selectedItems.indexOf(value)
    if (isPresent !== -1) {
      const remaining = selectedItems.filter((item: any) => item !== value)
      setSelectedItems(remaining)
    } else {
      setSelectedItems((prevItems: any) => [...prevItems, value])
    }
  }

  const validate = () => {
    // Check if the checkbox group is required, if so - make sure that atleast one is selected
    if (!required) {
      return true
    } else {
      const isValid = getValues(name).length > 0
      if (!isValid) {
        inputRef.current.setCustomValidity("Atleast one must be selected")
        inputRef.current.reportValidity()
        return "Atleast one must be selected"
      } else {
        return true
      }
    }
  }

  useEffect(() => {
    setValue(name, selectedItems)
  }, [selectedItems])

  const allOptions: string[] = JSON.parse(options)

  return (
    <fieldset className="o-form__item c-form__fieldset">
      <legend className="c-form__fieldset__legend">{label}</legend>
      <div className={"o-form__columns-" + columns}>
        {allOptions.map((option: string, index: number) => {
          return (
            <Controller
              name={name}
              control={control}
              key={option}
              rules={{ validate: validate }}
              render={({ field }) => {
                return (
                  <div className="c-form__checkbox" key={option}>
                    <input
                      {...field}
                      className="c-form__checkbox__input"
                      type="checkbox"
                      id={name + option}
                      checked={selectedItems.includes(option)}
                      onChange={() => handleSelect(option)}
                      ref={index === 0 ? inputRef : null}
                    />
                    <label
                      className="c-form__checkbox__label"
                      htmlFor={name + option}
                      dangerouslySetInnerHTML={{ __html: option }}
                    />
                  </div>
                )
              }}
            />
          )
        })}
      </div>
    </fieldset>
  )
}

export default FormInputMultiCheckbox
